const TYPE_ENVIRONMENT = {
  HTML: 'HML',
  PROD: 'PROD'
};

const ENTITY_TYPE = {
  USER: { DESCRIPTION: 'USER' },
  CUSTOMER: { DESCRIPTION: 'CUSTOMER' }
};

const ACCESS_VALUES = {
  ENABLED: 'H',
  DISABLED: 'D',
  HIDDEN: 'E'
};

const ACCESS = {
  PRE_VENDA: {
    OPERACOES_INTERNAS: 'PRE_VENDA_OPERACOES_INTERNAS',
    OPERACOES_EXTERNAS: 'PRE_VENDA_OPERACOES_EXTERNAS',
    OPERACOES_PROCESSAMENTO: 'PRE_VENDA_OPERACOES_PROCESSAMENTO',
    OPERACOES_CLIENTES: 'PRE_VENDA_OPERACOES_CLIENTES',
    OPERACOES_DOLSPAY: 'MENU_OPERACOES_DOLSPAY'
  },
  STABLECOIN: {
    DASHBOARD: 'STABLECOIN_DASHBOARD',
    ENVIAR_BANCO: 'STABLECOIN_ENVIAR_BANCO',
    CADASTRO_CONTA_BANCARIA: 'STABLECOIN_CADASTRO_CONTA_BANCARIA',
    OPERAR: 'STABLECOIN_OPERAR',
    AUMENTO_LIMITE: 'STABLECOIN_AUMENTO_LIMITE',
    RELATORIOS: {
      REMESSAS: 'STABLECOIN_RELATORIOS_REMESSAS',
      LUCRO_REMESSAS: 'STABLECOIN_RELATORIOS_LUCRO_REMESSAS'
    }
  },
  MENU: {
    DASHBOARD: 'MENU_DASHBOARD',
    CLIENTES: 'MENU_CLIENTES',
    FLUXO_CADASTRAL: 'MENU_FLUXO_CADASTRAL',
    OPERACOES: 'MENU_OPERACOES',
    RASCUNHO_OPERACOES: 'MENU_RASCUNHO_OPERACOES',
    OPERACOES_DOLSPAY: 'MENU_OPERACOES_DOLSPAY',
    GESTAO_DUIMP_DUE: 'MENU_GESTAO_DUIMP_DUE',
    RELATORIOS_OPERACIONAIS: {
      REMESSAS_INTERNACIONAIS: 'MENU_RELATORIOS_OPERACIONAIS_REMESSAS_INTERNACIONAIS',
      LUCRO_REMESSAS_INTERNACIONAIS: 'MENU_RELATORIOS_OPERACIONAIS_LUCRO_REMESSAS_INTERNACIONAIS',
      CONTA_CORRENTE_BANCOS: 'MENU_RELATORIOS_OPERACIONAIS_CONTA_CORRENTE_BANCOS',
      CAMBIO_TURISMO: 'MENU_RELATORIOS_OPERACIONAIS_CAMBIO_TURISMO',
      LUCRO_CAMBIO_TURISMO: 'MENU_RELATORIOS_OPERACIONAIS_LUCRO_CAMBIO_TURISMO'
    },
    CORBAN: {
      CADASTROS: 'MENU_CORBAN_CADASTROS',
      COMISSOES: 'MENU_CORBAN_COMISSOES'
    },
    CADASTROS_OPERACIONAIS: {
      NATUREZAS_OPERACAO: 'MENU_CADASTROS_OPERACIONAIS_NATUREZAS_OPERACAO',
      BANCOS: 'MENU_CADASTROS_OPERACIONAIS_BANCOS',
      SPREADS_MOEDAS: 'MENU_CADASTROS_OPERACIONAIS_SPREADS_MOEDAS',
      METODOS_PAGAMENTO: 'MENU_CADASTROS_OPERACIONAIS_METODOS_PAGAMENTO',
      APIS_COTACAO: 'MENU_CADASTROS_OPERACIONAIS_APIS_COTACAO',
      TEMPLATES: 'MENU_CADASTROS_OPERACIONAIS_TEMPLATES'
    },
    USUARIOS: 'MENU_USUARIOS',
    PERFIS: 'MENU_PERFIS',
    AUDITORIA: 'MENU_AUDITORIA',
    CLIENTE_DADOS_CADASTRAIS: 'MENU_CLIENTE_DADOS_CADASTRAIS',
    CLIENTE_SOCIOS: 'MENU_CLIENTE_SOCIOS',
    CLIENTE_CANAIS_BANCARIOS: 'MENU_CLIENTE_CANAIS_BANCARIOS',
    CLIENTE_DOCUMENTOS: 'MENU_CLIENTE_DOCUMENTOS',
    CLIENTE_BANCOS_LIMITES: 'MENU_CLIENTE_BANCOS_LIMITES',
    CLIENTE_SPREADS: 'MENU_CLIENTE_SPREADS',
    CLIENTE_HISTORICO: 'MENU_CLIENTE_HISTORICO',
    CONFIGURACOES: 'MENU_CONFIGURACOES',
    EMAILS_ENVIADOS: 'MENU_EMAILS_ENVIADOS',
    MENSAGENS_WHATSAPP: 'MENU_MENSAGENS_WHATSAPP',
    ALTERAR_SENHA: 'MENU_ALTERAR_SENHA',
    GERAR_INVOICES: 'MENU_GERAR_INVOICES',
    DASHBOARD_EDITAR: 'DASHBOARD_EDITAR',
    DASHBOARD_VISUALIZAR_CENARIOS: 'DASHBOARD_VISUALIZAR_CENARIOS',
    DASHBOARD_GERENCIAR_CENARIOS: 'DASHBOARD_GERENCIAR_CENARIOS',
    DASHBOARD_SALVAR_FILTRO: 'DASHBOARD_SALVAR_FILTRO',
    WHATSAPP_INBOX: 'MENU_WHATSAPP_INBOX'
  }
};

const PAGE_FORMAT = {
  A0: { value: 'A0', description: 'A0' },
  A1: { value: 'A1', description: 'A1' },
  A2: { value: 'A2', description: 'A2' },
  A3: { value: 'A3', description: 'A3' },
  A4: { value: 'A4', description: 'A4' },
  A5: { value: 'A5', description: 'A5' },
  A6: { value: 'A6', description: 'A6' },
  LETTER: { value: 'Letter', description: 'Carta' },
  LEGAL: { value: 'Legal', description: 'Ofício' },
  TABLOID: { value: 'Tabloid', description: 'Tabloide' }
};

const PAGE_ORIENTATION = {
  LANDSCAPE: { value: true, description: 'Paisagem' },
  PORTRAIT: { value: false, description: 'Retrato' }
};

const PAGE_FORMAT_LIST = Object.values(PAGE_FORMAT);

const PAGE_ORIENTATION_LIST = Object.values(PAGE_ORIENTATION);

const SOCKET_TITLE = {
  CONECTADO: 'Online',
  PRE_VENDA: 'PRE_VENDA',
  FICHA_ASSINADA: 'FICHA_ASSINADA',
  RECEIVER_ENVIADO: 'RECEIVER_ENVIADO',
  RECEIVER_APROVADO: 'RECEIVER_APROVADO',
  RECEIVER_PENDENTE: 'RECEIVER_PENDENTE',
  DUIMP_ATUALIZADO: 'DUIMP_ATUALIZADO',
  RECEIVER_FALHA: 'RECEIVER_FALHA'
};

const SOCKET_EVENT_NAME = {
  PRE_VENDA: 'preVenda',
  PRE_VENDA_EXTERNA: 'preVendaExterna',
  PRE_VENDA_CLIENTE: 'preVendaCliente',
  PRE_VENDA_DOLSPAY: 'preVendaDolsPay',
  PRE_VENDA_REMOVIDA: 'preVendaRemovida',
  FICHA_ASSINADA: 'fichaAssinada',
  LOCK_PRE_SALE: 'bloquearPreVenda',
  UNLOCK_PRE_SALE: 'desbloquearPreVenda',
  REFRESH_PRE_SALE_LOCK: 'atualizarBloqueioPreVenda',
  UPDATE_PRE_SALE_LOCK: 'alterarBloqueioPreVenda',
  REQUEST_PRE_SALE_LOCKS: 'solicitarBloqueiosPreVenda',
  RECEIVER_ENVIADO: 'receiverEnviado',
  RECEIVER_APROVADO: 'receiverAprovado',
  RECEIVER_PENDENTE: 'receiverPendente',
  STABLECOIN_TIMELINE_UPDATED: 'stablecoinTimelineUpdated',
  DUIMP_ATUALIZADO: 'duimpAtualizado',
  RECEIVER_FALHA: 'receiverFalha',
  // Fim do envio aos provedores depois de salvar a ficha: a tela segura o carregamento até ele
  RECEIVER_PROCESSAMENTO_CONCLUIDO: 'receiverProcessamentoConcluido',
  DOCUMENT_ANALYSIS_RESULT: 'documentAnalysisResult',
  BANK_ONBOARDING_STATUS_CHANGED: 'bankOnboardingStatusChanged',
  RFI_COMPLIANCE: 'rfiCompliance',
  LIMITE_AUMENTO: 'limiteAumento',
  // Cadastro aprovado sozinho após a aprovação no Dols Pay: o quadro do fluxo cadastral se atualiza
  CADASTRO_APROVADO_AUTOMATICO: 'cadastroAprovadoAutomatico',
  // Status do cadastro do cliente mudou (só socket): o quadro do fluxo cadastral se atualiza
  CUSTOMER_WORKFLOW_CHANGED: 'customerWorkflowChanged',
  // Recebimento/pagamento do DolsPay mudou: pré-venda, relatórios e pagamentos se atualizam
  STABLECOIN_PAYMENT_UPDATED: 'stablecoinPaymentUpdated',
  // Solicitação de pagamento de comissão virou "Urgente" (mais de 7 dias sem pagamento)
  COMISSAO_URGENTE: 'comissaoUrgente',
  COBRANCA_DUIMP_PENDENTE: 'cobrancaDuimpPendente',
  // Informativo publicado, editado ou cancelado: quem esta logado busca de novo os pendentes
  INFORMATIVOS_ATUALIZADOS: 'informativosAtualizados'
};

const FILE_FORMAT_SIGNATURE = {
  PDF: { id: 1, description: 'Pdf' }
};

const DOCUMENT_SIGNING_SOCKET_STATUS = {
  SIGNED: 'Signed',
  VIEWED: 'Viewed'
};

const SIGNATURE_SERVICE_PLAYER = {
  DOCUSIGN: { value: 'Docusign' },
  AUTENTIQUE: { value: 'Autentique' }
};

const SIGNATURE_SERVICE_PLAYER_LIST = Object.values(SIGNATURE_SERVICE_PLAYER);

const OTHER_PROFESSIONS_ID = 1;

const OTHER_ISSUING_AGENCIES_ID = 1;

const BUSINESS_VALIDATION = {
  TOTAL_SHARE_PERCENTAGE: 100
};

const EMAIL_LAYOUT_CONFIG = {
  GROUP: 'LAYOUT',
  SESSION: 'EMAIL',
  HEADER_NAME: 'EMAIL_LAYOUT_HEADER_HTML',
  FOOTER_NAME: 'EMAIL_LAYOUT_FOOTER_HTML',
  // Design do editor arrastável (JSON do Unlayer), para reabrir o cabeçalho/rodapé editável.
  HEADER_DESIGN_NAME: 'EMAIL_LAYOUT_HEADER_DESIGN',
  FOOTER_DESIGN_NAME: 'EMAIL_LAYOUT_FOOTER_DESIGN',
};

const OPERATION_DOCUMENT_TYPES = {
  CONTRATO: 1,
  SWIFT: 2,
  INVOICE: 3,
  COMPROVANTE_PAGAMENTO: 4
};

const BANKING_INTEGRATION_CUSTOMER_SOCKET_STATUS = {
  IN_PROCESSING: 'InProcessing',
  PROCESSING_COMPLETED: 'ProcessingCompletedSuccessfully',
  PROCESSING_COMPLETED_WITH_PROBLEMS: 'ProcessingCompletedWithProblems',
  PROCESSING_CANCELLED: 'ProcessingCancelled'
}

const BANKING_INTEGRATION_CUSTOMER_STATUS_CODE = {
  NOT_HANDLED: 0,
  WAITING_FOR_PROCESSING: 1,
  IN_PROCESSING: 2,
  PROCESSING_COMPLETED: 3,
  PROCESSING_COMPLETED_WITH_PROBLEMS: 4,
  PROCESSING_CANCELLED: 5
}

const BANKING_INTEGRATION_REGISTER_TYPE_CODE = {
  EVENTUAL: 1,
  PERMANENT: 2
}

const LIMIT_PROGRESSION_STATUS = {
  PENDING_CHECK: 'PENDING_CHECK',
  IN_ANALYSIS: 'IN_ANALYSIS',
  APPROVED: 'APPROVED'
}

/**
 * Mapeamento de status do socket (string) para código numérico usado internamente.
 */
const BANKING_INTEGRATION_SOCKET_TO_STATUS_CODE = {
  [BANKING_INTEGRATION_CUSTOMER_SOCKET_STATUS.IN_PROCESSING]: BANKING_INTEGRATION_CUSTOMER_STATUS_CODE.IN_PROCESSING,
  [BANKING_INTEGRATION_CUSTOMER_SOCKET_STATUS.PROCESSING_COMPLETED]: BANKING_INTEGRATION_CUSTOMER_STATUS_CODE.PROCESSING_COMPLETED,
  [BANKING_INTEGRATION_CUSTOMER_SOCKET_STATUS.PROCESSING_COMPLETED_WITH_PROBLEMS]: BANKING_INTEGRATION_CUSTOMER_STATUS_CODE.PROCESSING_COMPLETED_WITH_PROBLEMS,
  [BANKING_INTEGRATION_CUSTOMER_SOCKET_STATUS.PROCESSING_CANCELLED]: BANKING_INTEGRATION_CUSTOMER_STATUS_CODE.PROCESSING_CANCELLED,
}

const ACCOUNT_INTEGRATION_STATUS = {
  EM_ANALISE: 'EM_ANALISE',
  APROVADO: 'APROVADO',
  REJEITADO: 'REJEITADO',
};

const ACCOUNT_INTEGRATION_SOCKET_STATUS = {
  EM_ANALISE: 'EmAnalise',
  APROVADO: 'Aprovado',
  REJEITADO: 'Rejeitado',
};

/**
 * Mapeamento de status do socket de conta (string) para status interno.
 */
const ACCOUNT_INTEGRATION_SOCKET_TO_STATUS = {
  [ACCOUNT_INTEGRATION_SOCKET_STATUS.EM_ANALISE]: ACCOUNT_INTEGRATION_STATUS.EM_ANALISE,
  [ACCOUNT_INTEGRATION_SOCKET_STATUS.APROVADO]: ACCOUNT_INTEGRATION_STATUS.APROVADO,
  [ACCOUNT_INTEGRATION_SOCKET_STATUS.REJEITADO]: ACCOUNT_INTEGRATION_STATUS.REJEITADO,
};

export {
  TYPE_ENVIRONMENT,
  ENTITY_TYPE,
  ACCESS_VALUES,
  ACCESS,
  PAGE_FORMAT,
  PAGE_ORIENTATION,
  PAGE_FORMAT_LIST,
  PAGE_ORIENTATION_LIST,
  SOCKET_TITLE,
  SOCKET_EVENT_NAME,
  FILE_FORMAT_SIGNATURE,
  DOCUMENT_SIGNING_SOCKET_STATUS,
  SIGNATURE_SERVICE_PLAYER,
  SIGNATURE_SERVICE_PLAYER_LIST,
  BUSINESS_VALIDATION,
  EMAIL_LAYOUT_CONFIG,
  OTHER_PROFESSIONS_ID,
  OTHER_ISSUING_AGENCIES_ID,
  OPERATION_DOCUMENT_TYPES,
  BANKING_INTEGRATION_CUSTOMER_SOCKET_STATUS,
  BANKING_INTEGRATION_CUSTOMER_STATUS_CODE,
  BANKING_INTEGRATION_REGISTER_TYPE_CODE,
  BANKING_INTEGRATION_SOCKET_TO_STATUS_CODE,
  ACCOUNT_INTEGRATION_STATUS,
  ACCOUNT_INTEGRATION_SOCKET_STATUS,
  ACCOUNT_INTEGRATION_SOCKET_TO_STATUS,
  LIMIT_PROGRESSION_STATUS
};
